import React, { useState, useEffect } from 'react'
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input, message } from 'antd'
import styles from './index.less'
import { print } from "@/utils/printUtils"
import html2pdf from '@/utils/htmluploadpdf'
import createPdfDownload from '@/utils/html2pdf'
const { TextArea } = Input

const PrintModal = ({
  taskDetail = {},
  info = {},
  visible,
  onCancel,
  ...other
}) => {
  const [currentInfo, setCurrentInfo] = useState({})

  useEffect(() => {
    if (info) {
      setCurrentInfo({ ...info })
    }
  }, [info])

  const handlePrint = () => {
    const printContent = document.getElementById("printDetailsd").parentNode
    setTimeout(() => {
      print(printContent)
    }, 1500)
  }

  const handleUploadPdf = () => {
    message.info('正在生成上传PDF文件')
    const printContent = document.getElementById("printDetailsd").parentNode
    if (printContent) {
      html2pdf(printContent, currentInfo.id, 'period_evaluate_report', '/apis/custom_serve_report/period_evaluate_report/upload/')
    }
  }

  const handleCreateAndDownloadPdf = () => {
    message.success('正在下载')
    const printContent = document.getElementById('printDetailsd').parentNode
    if (printContent) {
      createPdfDownload(printContent)
    }
  }

  const modalProps = {
    visible: visible,
    width: 800,
    // okText: '打印',
    // footer: [
    //   <Button onClick={onCancel}>
    //     取消
    //   </Button>,
    //   <Button type="primary" onClick={handlePrint}>
    //     打印
    //   </Button>,
    //   <Button style={{ background: '#07c160', color: '#fff' }} onClick={handleUploadPdf}>
    //     分享3
    //   </Button>,
    // ],
    footer: null,
    ...other
  }

  const handleChange = (key, value) => {
    let newInfo = { ...currentInfo }
    newInfo[key] = value
    setCurrentInfo({ ...newInfo })
  }

  const handleArrChange = (key, index, value) => {
    let newInfo = { ...currentInfo }
    newInfo.serviceItemList[index][key] = value
    const totalAmount = newInfo.serviceItemList.reduce((total, cv) => {
      return total = (cv.purchaseCount * cv.expenseAmount) + total
    }, 0)
    const consumeTotalAmount = newInfo.serviceItemList.reduce((total, cv) => {
      return total = (cv.consumeCount * cv.consumeAmount) + total
    }, 0)
    const remainAmount = consumeTotalAmount - totalAmount
    newInfo.totalAmount = totalAmount
    newInfo.consumeTotalAmount = consumeTotalAmount
    newInfo.remainAmount = remainAmount
    setCurrentInfo({ ...newInfo })
  }

  return (
    <Modal {...modalProps} closable={false}
      title={<div style={{ height: 32 }}>
        <span style={{ float: 'left' }}>预览打印</span>
        <span style={{ float: 'right' }}>
          <Button style={{ marginRight: 5 }} type='primary' onClick={handleCreateAndDownloadPdf}>下载</Button>
          <Button style={{ marginRight: 5 }} type='primary' onClick={handlePrint}>打印</Button>
          <Button style={{ background: '#07c160', color: '#fff', marginRight: 5 }} onClick={handleUploadPdf}>分享</Button>
          <Button onClick={onCancel}>取消</Button>
        </span>
      </div>}>
      <div id='printDetailsd'>
        <div className={styles.BSPPrint}>
          <h2 className={'print-title'} style={{ textAlign: 'center' }}>{currentInfo.docName}</h2>
          <div className={'print-sub-title'} style={{ display: 'flex', justifyContent: 'space-between', lineHeight: '28px', fontSize: '14px', color: '#40a9ff' }}>
            <div>前段时间工作总结+后面工作计划安排</div>
            {/* <div>姓名：{currentInfo.customerName}</div> */}
          </div>
          <div className={styles.bspCommontContain}>
            <div className={styles.bspCommontContainChild4}>
              <Descriptions bordered column={4}>
                <Descriptions.Item className='descriptions25' span={1}>
                  <div className='likeTitle'>来访姓名：{currentInfo.customerName}</div>
                </Descriptions.Item>
                <Descriptions.Item className='descriptions25' span={1}>
                  <div className='likeTitle'>心理顾问：{currentInfo.consultantDoctorName}</div>
                </Descriptions.Item>
                <Descriptions.Item className='descriptions25' span={1}>
                  <div className='likeTitle'>心理师：{currentInfo.executorDoctorName}</div>
                </Descriptions.Item>
                <Descriptions.Item className='descriptions25' span={1}>
                  <div className='likeTitle'>日期：{currentInfo.serveDate}</div>
                </Descriptions.Item>
              </Descriptions>
            </div>
          </div>
          <div className={styles.bspCommontContain}>
            <div className={styles.bspCommontContainChild4}>
              <Descriptions bordered column={1}>
                <Descriptions.Item span={1}>
                  <Descriptions bordered column={6}>
                    <Descriptions.Item className='descriptions20' span={1}>
                      <div className='likeTitle'>服务项目</div>
                    </Descriptions.Item>
                    <Descriptions.Item className='descriptions30' span={1}>
                      <div className='likeTitle'>购买次数</div>
                    </Descriptions.Item>
                    {/* <Descriptions.Item className='descriptions15' span={1}>
                      <div className='likeTitle'>费用金额</div>
                    </Descriptions.Item> */}
                    <Descriptions.Item className='descriptions30' span={1}>
                      <div className='likeTitle'>已消耗次数</div>
                    </Descriptions.Item>
                    {/* <Descriptions.Item className='descriptions15' span={1}>
                      <div className='likeTitle'>已消耗金额</div>
                    </Descriptions.Item> */}
                    <Descriptions.Item className='descriptions20' span={1}>
                      <div className='likeTitle'>备注</div>
                    </Descriptions.Item>
                  </Descriptions>
                </Descriptions.Item>
                {
                  currentInfo.serviceItemList && currentInfo.serviceItemList.map((_, index) => {
                    return <Descriptions.Item span={1}>
                      <Descriptions bordered column={6}>
                        <Descriptions.Item className='descriptions20' span={1}>
                          <div className='likeValue'>{_.serveItemName}</div>
                        </Descriptions.Item>
                        <Descriptions.Item className='descriptions30' span={1}>
                          <div className='likeValue'><Input value={_.purchaseCount} autoSize={{ minRows: 1 }} onChange={e => handleArrChange('purchaseCount', index, e.target.value)} /></div>
                        </Descriptions.Item>
                        {/* <Descriptions.Item className='descriptions15' span={1}>
                          <div className='likeValue'><Input value={_.expenseAmount} autoSize={{ minRows: 1 }} onChange={e => handleArrChange('expenseAmount', index, e.target.value)} /></div>
                        </Descriptions.Item> */}
                        <Descriptions.Item className='descriptions30' span={1}>
                          <div className='likeValue'><Input value={_.consumeCount} autoSize={{ minRows: 1 }} onChange={e => handleArrChange('consumeCount', index, e.target.value)} /></div>
                        </Descriptions.Item>
                        {/* <Descriptions.Item className='descriptions15' span={1}>
                          <div className='likeValue'><Input value={_.consumeAmount} autoSize={{ minRows: 1 }} onChange={e => handleArrChange('consumeAmount', index, e.target.value)} /></div>
                        </Descriptions.Item> */}
                        <Descriptions.Item className='descriptions20' span={1}>
                          <div className='likeValue'><Input value={_.remark} autoSize={{ minRows: 1 }} onChange={e => handleArrChange('remark', index, e.target.value)} /></div>
                        </Descriptions.Item>
                      </Descriptions>
                    </Descriptions.Item>
                  })
                }
                <Descriptions.Item span={1}>
                  <Descriptions bordered column={6}>
                    <Descriptions.Item className='descriptions20' span={1}>
                      <div className='likeValue'>总计</div>
                    </Descriptions.Item>
                    <Descriptions.Item className='descriptions30' span={1}>
                      {/* <div className='likeValue'><TextArea value={currentInfo.totalAmount} autoSize={{ minRows: 1 }} onChange={e => handleChange('totalAmount', e.target.value)} /></div> */}
                      <div className='likeValue'>{currentInfo.purchaseTotalCount}</div>
                    </Descriptions.Item>
                    <Descriptions.Item className='descriptions30' span={1}>
                      {/* <div className='likeValue'><TextArea value={currentInfo.consumeTotalAmount} autoSize={{ minRows: 1 }} onChange={e => handleChange('consumeTotalAmount', e.target.value)} /></div> */}
                      <div className='likeValue'>{currentInfo.consumeTotalCount}</div>
                    </Descriptions.Item>
                    <Descriptions.Item className='descriptions20' span={1}>
                      <div className='likeValue'>余: {currentInfo.leaveTotalCount}</div>
                    </Descriptions.Item>
                  </Descriptions>
                </Descriptions.Item>
              </Descriptions>
            </div>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className='title'><div>整体情况总结</div></h3>
            <Descriptions bordered column={1}>
              <Descriptions.Item span={1} label="问题类型">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.problemCategory || taskDetail.questionTypeTwo}
                  {/* <TextArea value={currentInfo.problemCategory || taskDetail.questionTypeTwo} autoSize={{ minRows: 1 }} onChange={e => handleChange('problemCategory', e.target.value)} /> */}
                </div>
              </Descriptions.Item>
              <Descriptions.Item span={1} label="BPS好转情况总结">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.overallSummary || '参考模板：来访情绪睡眠有改善，跟父母关系有好转'}
                  {/* <TextArea value={currentInfo.overallSummary || '参考模板：来访情绪睡眠有改善，跟父母关系有好转'} autoSize={{ minRows: 2 }} onChange={e => handleChange('overallSummary', e.target.value)} /> */}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </div>
          <div className={styles.bspCommontContain}>
            <h3 className='title'><div>阶段性评估概述</div></h3>
            <Descriptions bordered column={1}>
              <Descriptions.Item span={1} label="咨询反馈">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.consultFeedback || `参考模板：请填写来访经历过几次咨询之后收集的动态信息和成长变化 `}
                  {/* <TextArea style={{ whiteSpace: 'pre-wrap' }} value={currentInfo.consultFeedback || `参考模板：请填写来访经历过几次咨询之后收集的动态信息和成长变化 `} autoSize={{ minRows: 5 }} onChange={e => handleChange('consultFeedback', e.target.value)} /> */}
                </div>
              </Descriptions.Item>
              <Descriptions.Item span={1} label="家庭作业">
                <div style={{ padding: '8px 16px' }}>
                  <TextArea value={currentInfo.homework} placeholder='来访在家仍可以做的事情，比如运动、冥想、注意事项' autoSize={{ minRows: 4 }} onChange={e => handleChange('homework', e.target.value)} />
                </div>
              </Descriptions.Item>
              <Descriptions.Item span={1} label="待突破议题">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.waitingResolve || `参考模板：请填写来访还持续的存在的议题和新增的潜在议题 `}
                  {/* <TextArea value={currentInfo.waitingResolve || `参考模板：请填写来访还持续的存在的议题和新增的潜在议题 `} autoSize={{ minRows: 4 }} onChange={e => handleChange('waitingResolve', e.target.value)} /> */}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </div>
          {/* <div className={styles.bspCommontContain}>
            <h3 className='title'><div>BPS评估总结</div></h3>
            <Descriptions bordered column={1}>
              <Descriptions.Item span={1} label="原因+细化问题表现">
                <div className={styles.bspCommontContainChild4} >
                  <Descriptions bordered column={1}>
                    <Descriptions.Item span={3}>
                      <div>
                        <Descriptions bordered column={3}>
                          <Descriptions.Item className='descriptions33' span={1}>
                            <Descriptions bordered column={2}>
                              <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px 4px' }}>生物（症状表现）</div></Descriptions.Item>
                              <Descriptions.Item className='descriptions4' span={1}>
                                <div style={{ padding: '8px 4px', minHeight: 45, textAlign: 'center', lineHeight: '90px', color: 'red' }}>
                                  <TextArea value={currentInfo.biologyLevel || '中度'} autoSize={{ minRows: 3 }} onChange={e => handleChange('biologyLevel', e.target.value)} />
                                </div>
                              </Descriptions.Item>
                            </Descriptions>
                          </Descriptions.Item>
                          <Descriptions.Item className='descriptions33' span={1}>
                            <Descriptions bordered column={2}>
                              <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px 4px' }}>心理（原生家庭+人格特质）</div></Descriptions.Item>
                              <Descriptions.Item className='descriptions4' span={1}>
                                <div style={{ padding: '8px 4px', minHeight: 45, textAlign: 'center', lineHeight: '90px', color: 'red' }}>
                                  <TextArea value={currentInfo.psychologyLevel || '中度'} autoSize={{ minRows: 3 }} onChange={e => handleChange('psychologyLevel', e.target.value)} />
                                </div>
                              </Descriptions.Item>
                            </Descriptions>
                          </Descriptions.Item>
                          <Descriptions.Item className='descriptions33' span={1}>
                            <Descriptions bordered column={2}>
                              <Descriptions.Item className='descriptions3' span={1}><div style={{ padding: '8px 4px' }}>社会（家庭婚恋、职场学业困扰</div></Descriptions.Item>
                              <Descriptions.Item className='descriptions4' span={1}>
                                <div style={{ padding: '8px 4px', minHeight: 45, textAlign: 'center', lineHeight: '90px', color: 'red' }}>
                                  <TextArea value={currentInfo.socialLevel || '中度'} autoSize={{ minRows: 3 }} onChange={e => handleChange('socialLevel', e.target.value)} />
                                </div>
                              </Descriptions.Item>
                            </Descriptions>
                          </Descriptions.Item>
                        </Descriptions>
                      </div>
                    </Descriptions.Item>
                    <Descriptions.Item span={3}>
                      <div>
                        <Descriptions bordered column={5}>
                          <Descriptions.Item className='descriptions33' span={1}>
                            <div style={{ padding: 8 }}>
                              <TextArea value={currentInfo.biologySummary || '请填写当前评估阶段，来访在情绪、认知、行为、睡眠等维度的改善情况'} autoSize={{ minRows: 5 }} onChange={e => handleChange('biologySummary', e.target.value)} />
                            </div>
                          </Descriptions.Item>
                          <Descriptions.Item className='descriptions33' span={2}>
                            <div style={{ padding: 8 }}>
                              <TextArea value={currentInfo.psychologySummary || '请填写当前评估阶段，来访性格、成长经历、教育方式等维度问题的改善情况'} autoSize={{ minRows: 5 }} onChange={e => handleChange('psychologySummary', e.target.value)} />
                            </div>
                          </Descriptions.Item>
                          <Descriptions.Item className='descriptions33' span={2}>
                            <div style={{ padding: 8 }}>
                              <TextArea value={currentInfo.socialSummary || '请填写当前评估阶段，来访在家庭婚恋亲子、学习工作中的适应能力、人际等问题的改善情况'} autoSize={{ minRows: 5 }} onChange={e => handleChange('socialSummary', e.target.value)} />
                            </div>
                          </Descriptions.Item>
                        </Descriptions>
                      </div>
                    </Descriptions.Item>
                  </Descriptions>
                </div>
              </Descriptions.Item>
            </Descriptions>
          </div> */}
          <div className={styles.bspCommontContain}>
            <h3 className='title'><div>BPS-DPP循程服务下阶段工作计划</div></h3>
            <Descriptions bordered column={1}>
              <Descriptions.Item span={1} label="目标方向">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.targetDirection || `参考模板：\n 请从生物心理社会三个维度给来访规划\n1. 让情绪保持持续稳定，提升情绪管理复原力和抗压能力，促进人际关系改善\n2. 提升自我认知评价体系\n3. 改善亲密关系`}
                  {/* <TextArea value={currentInfo.targetDirection || `参考模板：\n 请从生物心理社会三个维度给来访规划\n1. 让情绪保持持续稳定，提升情绪管理复原力和抗压能力，促进人际关系改善\n2. 提升自我认知评价体系\n3. 改善亲密关系`} autoSize={{ minRows: 5 }} onChange={e => handleChange('targetDirection', e.target.value)} /> */}
                </div>
              </Descriptions.Item>
              <Descriptions.Item span={1} label="工作安排">
                <div style={{ padding: '8px 16px' }}>
                  {currentInfo.workSchedule || `参考模板\n1. 个体心理咨询建议由原一周2次调整为一周1次\n2. 居家心理训练建议由原一周2次调整为一周5次\n3. 建议改为家医服务`}
                  {/* <TextArea value={currentInfo.workSchedule || `参考模板\n1. 个体心理咨询建议由原一周2次调整为一周1次\n2. 居家心理训练建议由原一周2次调整为一周5次\n3. 建议改为家医服务`} autoSize={{ minRows: 4 }} onChange={e => handleChange('workSchedule', e.target.value)} /> */}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </div>
          {
            currentInfo.imageArray && currentInfo.imageArray.map(it => {
              return <img style={{ width: 750 }} src={it} />
            })
          }
        </div>
      </div>
    </Modal>

  )
}

export default Form.create()(PrintModal)
